<!-- 工作报表 -->
<template>
  <div class="container">
    <div class="vue">
      <div class="header flex flexAi-c">
        <div class="text">工作报表管理</div>
      </div>
      <div class="content">
        <el-table
          :header-cell-style="{ background: '#f5f5f5' }"
          :data="reportList.list"
          style="width: 100%"
        >
          <el-table-column prop="id" label="#"> </el-table-column>
          <el-table-column prop="tel" label="手机号"> </el-table-column>
          <el-table-column prop="servername" label="姓名"> </el-table-column>

          <el-table-column label="状态">
            <template slot-scope="scope">
              {{ scope.row.free | filterNum('空闲', '工作中') }}
            </template>
          </el-table-column>
          <el-table-column label="正在执行订单">
            <template slot-scope="scope">
              <el-link
                v-if="scope.row.free == 0"
                :underline="false"
                type="primary"
                >---</el-link
              >
              <el-link
                v-else
                :underline="false"
                type="primary"
                @click="editBut(scope.row)"
                >查看</el-link
              >
            </template>
          </el-table-column>
          <el-table-column label="工作报表">
            <template slot-scope="scope">
              <el-link
                :underline="false"
                type="primary"
                @click="statementBut(scope.row)"
                >查看</el-link
              >
            </template>
          </el-table-column>
          <el-table-column label="变为普通用户">
            <template slot-scope="scope">
              <el-popconfirm
                @confirm="alterStateBut(scope.row)"
                title="是否更改为普通用户？"
              >
                <el-link slot="reference" :underline="false" type="primary"
                  >更改</el-link
                >
              </el-popconfirm>
            </template>
          </el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <el-link
                :underline="false"
                type="primary"
                @click="editBut(scope.row)"
                >编辑</el-link
              >
              <el-popconfirm
                style="padding-left:10px"
                @confirm="delBut(scope.row)"
                title="删除后无法找回，确定删除吗？"
              >
                <el-link slot="reference" :underline="false" type="primary"
                  >删除</el-link
                >
              </el-popconfirm>
            </template>
          </el-table-column>
        </el-table>
        <div class="Pagination flex">
          <div class="text">
            <span>共{{ ServiceList.total }}条记录，</span>
            <span class="pageNum">{{ ServiceList.pageNum }}</span>
            <span>/{{ ServiceList.pages }}页</span>
          </div>
          <el-pagination
            @current-change="handleCurrentChange"
            :current-page.sync="ServiceList.pageNum"
            :page-size="ServiceList.pageSize"
            layout="prev, pager, next, jumper"
            :total="ServiceList.total"
          >
          </el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  apiGetDaily,
  apiChangeServerToUsers,
  apiDelServer
} from '@/api/management'

export default {
  name: '',
  props: [''],
  data() {
    return {
      reportList: [], // 列表
      routerObj: '',
      pages: {
        page: 1, // 页数
        size: 20
      }
    }
  },

  components: {},

  computed: {},

  beforeMount() {},

  mounted() {
    if (this.$route.query.info !== undefined) {
      this.routerObj = JSON.parse(this.$Base64.decode(this.$route.query.info))
      console.log(this.routerObj)

      this.GetDaily()
    }
  },

  methods: {
    // 变为普通用户
    alterStateBut(row) {
      apiChangeServerToUsers({
        id: row.id
      }).then(res => {
        if (res.status === 0) {
          this.$Ms(res.msg)
          this.GetServiceList()
        } else if (res.status === 1) {
          this.$Me(res.msg)
        }
      })
    },
    // 工作报表
    statementBut(row) {},
    // 列表删除
    delBut(row) {
      apiDelServer({
        id: row.id
      }).then(res => {
        if (res.status === 0) {
          this.$Ms(res.msg)
          this.GetServiceList()
        } else if (res.status === 1) {
          this.$Me(res.msg)
        }
      })
      console.log(row)
    },
    // 列表修改
    editBut(row) {
      console.log(row)
      this.$router.push({
        path: '/AddPersonnelStatus',
        query: {
          info: this.$Base64.encode(JSON.stringify(row))
        }
      })
    },

    // 分页
    handleCurrentChange(val) {
      this.pages.page = val
      console.log(`当前页: ${val}`)
      this.GetServiceList()
    },
    // 接口
    // 获取服务人员的列表
    GetDaily() {
      apiGetDaily({
        id: this.routerObj.id
      }).then(res => {
        if (res.status === 0) {
          this.reportList = res.data
        }
      })
    }
  },

  watch: {}
}
</script>
<style lang="scss" scoped>
.FZ0875 {
  font-size: 0.875em;
}
.textalignLeft {
  text-align: left;
}
.vue {
  background-color: #fff;
  border-left: 2px solid #119685;
  .header {
    height: 52px;
    justify-content: space-between;
    .text {
      text-align: left;
      // font-size: 0.875em;
      color: #119685;
      padding: 10px 5px;
    }
    .el-button {
      margin: 10px;
    }
  }
  .content {
    height: calc(100vh - 172px);
    flex-direction: column;
    align-items: center;
    justify-content: center;
    .el-table {
      overflow: auto;
      height: calc(100vh - 224px);
    }
    /deep/ .el-table .warning-row {
      background: oldlace;
    }

    /deep/ .el-table .success-row {
      background: #f0f9eb;
    }
    .Pagination {
      justify-content: space-between;
      padding: 10px 20px;
      align-items: center;
      font-size: 0.875em;
      color: #7b7b7b;
      .text {
        .pageNum {
          color: #119685;
        }
      }
    }
  }
}
.dialog {
}
</style>
